import FactureCommercial from './FactureCommercial';
export default class Commercial {
  constructor(data) {
    this.check = false;
    this.name = data.name;
    this.total_net_ht = data.total_ht;
    this.total_tva = data.total_tva;
    this.total_ttc = data.total_ttc;
    this.factures = data.factures.map(facture =>
      FactureCommercial.create(facture)
    );
  }
  static create(data) {
    return new Commercial(data);
  }
}
